import React from "react"

const SOURCE_DECOMMISSION_THRESHOLD = 10
const SOURCE_WARNING_THRESHOLD = 1

const SourceViewErrorDetails = ({ sourceRequestErrorCount }) => (
    <div className="widget">
        <div className="widget-content">
            <h3 className="first-heading">
                <i className="icon icon-headline" />Warnings
            </h3>
            <p style={{ color: getTextColor(sourceRequestErrorCount) }}>
                {getErrorMessage(sourceRequestErrorCount)}
            </p>
        </div>
    </div>
)

function getErrorMessage(sourceRequestErrorCount) {
    if (sourceRequestErrorCount >= SOURCE_DECOMMISSION_THRESHOLD) {
        return "This source has been deactivated due to repeated errors when requesting its contents. Please check the URL is correct and then re-activate it."
    } else if (sourceRequestErrorCount >= SOURCE_WARNING_THRESHOLD) {
        return "This source is experiencing errors when requesting its contents. Please check the URL is correct."
    } else {
        return "No errors."
    }
}

function getTextColor(sourceRequestErrorCount) {
    if (sourceRequestErrorCount >= SOURCE_DECOMMISSION_THRESHOLD) {
        return "red"
    } else if (sourceRequestErrorCount >= SOURCE_WARNING_THRESHOLD) {
        return "orange"
    } else {
        return "black"
    }
}

export default SourceViewErrorDetails
